<template>
  <div id="inspection">
    <div class="firstPart">
      <div class="topPart">
        <h2 class="title">智慧巡检</h2>
      </div>
      <el-row :gutter="50" class="elRow">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="center">
          <img
            src="../../../assets/img/product/zhxj.png"
            alt=""
            class="leftImg"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="left">
          <div class="rightInfo wow fadeInUp">
            <div class="introTxt">
              智慧巡检系统定时生成巡检任务，工作人员通过手机完成巡检工作，并记录各点位巡检工作完成情况，管理人员可随时调阅。
            </div>
            <div class="typeBox">
            <el-row :gutter="20" style="width:100%">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="typeItem">
                        <img src="../../../assets/img/product/ewm.png" alt="" class="typeImg" />
                        <div class="typeInfo">
                        <div class="typeName">二维码巡检</div>
                        <div class="typeEffect">成本低</div>
                        <div class="typeEffect">支持既有二维码</div>
                        <div class="typeEffect">一码多用</div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="typeItem">
                        <img src="../../../assets/img/product/nfc.png" alt="" class="typeImg" />
                        <div class="typeInfo">
                        <div class="typeName">NFC巡检</div>
                        <div class="typeEffect">自带加密算法</div>
                        <div class="typeEffect">有效防止作弊</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="secondPart">
      <div class="title2">智慧巡检主要功能</div>
      <el-row :gutter="20" class="elRow">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="inspeItem wow animate__zoomIn">
            <div class="leftBox leftBg">
              <img
                src="../../../assets/img/product/xunjianqingdan.svg"
                alt=""
              />
            </div>
            <div class="rightBox">
              <div class="boxName">巡检清单</div>
              <div class="boxDesc">
                系统可以针对不同时间、不同点位、不同巡检人分别定义巡检内容清单，预设每个人物需巡检项目及巡检结果，实现巡检工作精细化管理。
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="inspeItem wow animate__zoomIn">
            <div class="leftBox middleBg">
              <img
                src="../../../assets/img/product/lixianhuancun .svg"
                alt=""
              />
            </div>
            <div class="rightBox">
              <div class="boxName">离线缓存</div>
              <div class="boxDesc">
                系统支持对巡检人物本地缓存、离线巡检，有效解决了无线网络信号弱、无覆盖地区巡检对问题。
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="inspeItem wow animate__zoomIn">
            <div class="leftBox rightBg">
              <img src="../../../assets/img/product/guijihuifang.svg" alt="" />
            </div>
            <div class="rightBox">
              <div class="boxName">轨迹回放</div>
              <div class="boxDesc">
                执行巡检工作时，App将实时记录巡检人位置，并上报至系统平台或缓存与本地，平台将通过地图叠加轨迹方式展现给用户。
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="thirdPart">
      <div class="topPart">
        <div class="title">隐患处理闭环</div>
        <div class="intro">
          对于已发现隐患，由巡检人员通过文字、图片等方式上报，系统根据流程配置，推送给对应的管理、执行人员，并跟踪管理、记录每一次操作详细信息，直至隐患问题解决，完成隐患处置闭环。
        </div>
      </div>
      <div class="stepRow">
        <div class="stepBox">
          <img src="../../../assets/img/product/shangbao.svg" alt="" />
          <div class="stepName">上报</div>
        </div>
        <div class="stepLine"></div>
        <div class="stepBox">
          <img src="../../../assets/img/product/zhipai.svg" alt="" />
          <div class="stepName">指派</div>
        </div>
        <div class="stepLine"></div>
        <div class="stepBox">
          <img src="../../../assets/img/product/chuzhi.svg" alt="" />
          <div class="stepName">处置</div>
        </div>
        <div class="stepLine"></div>
        <div class="stepBox">
          <img src="../../../assets/img/product/heshi.svg" alt="" />
          <div class="stepName">核实</div>
        </div>
      </div>
    </div>
    <div class="fourthPart">
      <div class="title2">掌上智慧巡检&隐患管理</div>
      <div class="bannerRow">
        <swiper :options="swiperOption1" ref="mySwiper">
          <swiper-slide>
            <img src="../../../assets/img/product/gl.png" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../../assets/img/product/xj3.png" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../../assets/img/product/yh.png" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../../assets/img/product/xj2.png" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../../assets/img/product/xj1.png" alt="" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  props: {},
  data() {
    return {
      swiperOption1: {
        loop: true,
        autoplay: false,
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 10,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    //   this.screenWidth = document.body.clientWidth;
    //   console.log(this.screenWidth);

    //     window.onresize = () => {
    //     return (() => {
    //       this.bannerFlag = this.screenWidth<=768?2:1;
    //     })()
    //   }


    // if (this.screenWidth <= 768) {
    //     this.otherShow = true;
    //     this.PCshow = false;
    // }else{
    //     this.PCshow = true;
    //     this.otherShow = false;
    // }

    new WOW({ live: false }).init();
  },
  watch: {
    //   screenWidth:function(newVal,old){
    //       console.log(newVal);
    //   }
  },
  methods: {},
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style scoped lang="scss">
#inspection {
  background: linear-gradient(91deg, #fdfdfd, #eff5f9);
  .topPart {
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 6rem;
    .title {
      font-size: 2.6rem;
      color: #333333;
        margin-bottom: 2rem;
    }
    .intro {
      width: 60%;
      color: #999999;
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: justify;
      text-justify: inter-ideograph; /*IE*/
    }
  }
  @media screen and (max-width: 414px) {
    .topPart {
      .intro {
        width: 100%;
      }
    }
  }
  .firstPart {
    padding: 5% 14%;
    .elRow {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .leftImg {
      width: 75%;
    }
    .rightInfo {
      height: 100%;
      .introTxt {
        color: #999999;
        line-height: 2.6rem;
        font-size: 1.6rem;
        margin-bottom: 5rem;
      }
      .typeBox{
      display: flex;
      justify-content: space-between;
        .typeItem{
           width: 100%;
           height: 20rem;
           background: #ffffff;
           border-radius: 4px;
           padding: 3rem 4rem;
           display: flex;
           justify-content: flex-start;
        }
        .typeImg{
            width: 4rem;
            height: 4rem;
            margin-right: 3rem;
        }
        .typeInfo{
            .typeName{
                font-size: 1.8rem;
                font-weight: 500;
                color: #333333;
                line-height: 4rem;
                margin-bottom: 1rem;
            }
            .typeEffect{
                font-size: 1.6rem;
                font-weight: 400;
                color: #696969;
                line-height: 3rem;
            }
        }
      }
    }
  }

  .secondPart {
    padding: 5% 14%;
    .title2 {
      color: #333333;
      line-height: 5rem;
      font-size: 2.6rem;
      text-align: center;
    }
    .elRow {
      display: flex;
      flex-wrap: wrap;
      .inspeItem {
        display: flex;
        justify-content: space-evenly;
        padding: 3rem;
        height: 24rem;
        background: #ffffff;
        box-shadow: 0px 3px 60px 0px rgba(186, 186, 186, 0.19);
        border-radius: 8px;
        margin-top: 4rem;
        height: 20rem;
        &:hover {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
          transform: translate(0, -5px);
          transition: all 0.3s;
        }

        .leftBox {
          border-radius: 50%;
          width: 6.6rem;
          height: 6.6rem;
        }
        .rightBox {
          text-align: left;
          margin-left: 3rem;
          width: 70%;
          .boxName {
            font-size: 1.6rem;
            color: #333333;
            line-height: 4rem;
            margin-bottom: 2rem;
          }
          .boxDesc {
            font-size: 1.4rem;
            color: #666666;
            line-height: 2.6rem;
            text-justify: inter-ideograph;
            text-align: justify;
          }
        }
      }
    }
  }
  .thirdPart {
    padding: 5% 14%;
    background-image: url("../../../assets/img/product/flowbg.png");
    background-position: center;
    background-size: 100% 100%;
    color: #ffffff;
    .title {
      color: #ffffff;
    }
    .line {
      border-bottom: 0.2rem solid #fff;
    }
    .intro {
      color: #fff;
    }
  }
  .fourthPart {
    padding: 5% 14%;
    .title2 {
      color: #333333;
      line-height: 5rem;
      font-size: 2.6rem;
      text-align: center;
    }
    .bannerRow {
      text-align: center;
      padding-top: 4rem;
      .swiper-container {
        height: 50rem;
      }
      .swiper-wrapper {
        justify-content: center;
      }
      .swiper-slide {
        height: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 70%;
          height: 80%;
          object-fit: contain;
        }
      }
      .swiper-slide-active {
        transform: scale(1.15);
        transition: all 0.3s;
        justify-content: center;
        img {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
        }
      }
    }
  }
}
@import "../../../assets/responsive/inspection.scss";
</style>
